import script from "./PromotionManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./PromotionManagement.vue?vue&type=script&setup=true&lang=js"

import "./PromotionManagement.vue?vue&type=style&index=0&id=4a58a361&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a58a361"]])

export default __exports__